import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RequestBodyConverter } from '../RequestBodyConverter';
import { useParams } from 'react-router-dom';
import WebMatchPredictionForm from './WebMatchPredictionForm';
// import { initialValues  } from './initialValues-testing';
import { showWebMatchPredictionApi, updateWebMatchPredictionApi, clearEditedWebMatchPrediction } from './webMatchPredictionSlice';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import { PICTURE_ATTRIBUTE_NAMES } from '~/config/constants';

function WebMatchPredictionUpdate() {
    const { id } = useParams();
    const [resetCount, setResetCount] = useState(0);
    const { editedModel: initialValues } = useSelector((state) => state.eventSaga.webMatchPrediction);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const formSubmit = async (rawValues) => {
        let values = new RequestBodyConverter(rawValues);
        values = values.data;
        dispatch(clearApiValidationErrors()); //clear current api validation errors if any.
        dispatch(updateWebMatchPredictionApi({ navigate, values, id }));
    };

    useEffect(() => {
        dispatch(showWebMatchPredictionApi({ navigate, id }));

        return () => dispatch(clearEditedWebMatchPrediction());
    }, []);

    return (
        <WebMatchPredictionForm
            resetCount={resetCount}
            setResetCount={setResetCount}
            pictureAttributeNames={PICTURE_ATTRIBUTE_NAMES}
            initialValues={initialValues}
            formSubmit={formSubmit}
        />
    );
}

export default WebMatchPredictionUpdate;
